// extracted by mini-css-extract-plugin
export default {"rightSide":"browse-file_rightSide__ciKND","infoIcon":"browse-file_infoIcon__Kx0uc","errorRow":"browse-file_errorRow__vjBVa","alertIcon":"browse-file_alertIcon__qnlE8"};